import React from 'react'
import { M_Button, M_InputTextField, M_DrawerTableTextField } from 'src/components/M_Components'

export default function AddressList({ optionsAddress, address, addAddress, deleteAddress, createStructureAddress, orderService, t }) {

    return (
        <div className='cardOrderService'>
            <div className='divTitleCard'>
                <div className='divAlignTitleStatus'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/home.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Address"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("Address")}
                    </div>
                </div>
                <div className='divLabelStatus'>
                    <M_Button
                        label={t("AddLocal")}
                        icon={<img src="/icons/svgsDaNet/add-circle.svg"
                            style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                            alt="save" />
                        }
                        borderColor={'var(--color-grey)'}
                        onClick={addAddress}
                    />
                </div>
            </div>
            <div className='divOverflowAddresses'>
                {address.map((addr, index) => (
                    <div className='divGlobalBlockAddress' key={index}>
                        <div className="divAlignInputCodeAddress">
                            <div className='divTileCardAddress'>
                                <img
                                    src={addr.AddressType === 'Pickup' ? "/icons/svgsDaNet/arrow-narrow-up.svg" :
                                        addr.AddressType === 'Delivery' ? "/icons/svgsDaNet/arrow-narrow-down.svg" :
                                            "/icons/svgsDaNet/crane.svg"
                                    }
                                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                    alt="Levante" className='iconCardAddress'
                                />
                                <div className='labelCardAddress'>
                                    {t(`${addr.AddressType} Point`)}
                                </div>
                            </div>
                        </div>
                        <div className='divAlignInputsFormAddress'>
                            {optionsAddress.filter((elem) => elem.IsHiddenList !== true).map((address1, key1) => (
                                <div key={key1}>
                                    {address1.IsForeignKey ? (
                                        <M_DrawerTableTextField
                                            tableLabel={address1.NormalizedName}
                                            label={address1.NormalizedName}
                                            required={address1.IsRequired}
                                            entity={address1.ForeignTableName}
                                            value={addr[address1.ForeignTableToPassId] &&
                                            {
                                                [address1.ForeignTableToPassId]: addr[address1.ForeignTableToPassId],
                                                [address1.ForeignKeyName]: addr[address1.Name]
                                            } || null}
                                            filterField={address1.ForeignKeyName}
                                            labelFields={[address1.ForeignKeyName]}
                                            onSubmitValue={obj => {
                                                if (obj && obj !== undefined) {
                                                    createStructureAddress(obj[address1.ForeignKeyName] || '', address1.Name, addr.Id)
                                                    createStructureAddress(obj[address1.ForeignTableToPassId] || '', address1.ForeignTableToPassId, addr.Id)
                                                    createStructureAddress(obj.AddressName || '', 'AddressName', addr.Id)
                                                    createStructureAddress(obj.AddressPlace || '', 'AddressPlace', addr.Id)
                                                    createStructureAddress(obj.AddressStreet || '', 'AddressStreet', addr.Id)
                                                    createStructureAddress(obj.AddressZipCode || '', 'AddressZipCode', addr.Id)
                                                    createStructureAddress(obj.AddressZipPlace || '', 'AddressZipPlace', addr.Id)
                                                    createStructureAddress(obj.Notes || '', 'Notes', addr.Id)
                                                    createStructureAddress(obj.CountryCode || '', 'CountryCode', addr.Id)
                                                    if (addr.AddressType !== 'Charge/Discharge') {
                                                        createStructureAddress(obj.InitialDate || '', 'InitialDate', addr.Id)
                                                        createStructureAddress(obj.FinalDate || '', 'FinalDate', addr.Id)
                                                    }
                                                } else {
                                                    createStructureAddress('', address1.Name, addr.Id)
                                                    createStructureAddress('', address1.ForeignTableToPassId, addr.Id)
                                                    createStructureAddress('', 'AddressName', addr.Id)
                                                    createStructureAddress('', 'AddressPlace', addr.Id)
                                                    createStructureAddress('', 'AddressStreet', addr.Id)
                                                    createStructureAddress('', 'AddressZipCode', addr.Id)
                                                    createStructureAddress('', 'CountryCode', addr.Id)
                                                    createStructureAddress('', 'AddressZipPlace', addr.Id)
                                                    createStructureAddress('', 'Notes', addr.Id)
                                                    if (addr.AddressType !== 'Charge/Discharge') {
                                                        createStructureAddress('', 'InitialDate', addr.Id)
                                                        createStructureAddress('', 'FinalDate', addr.Id)
                                                    }
                                                }
                                                if (address1.Name === 'CountryCode') {
                                                    if (obj) {
                                                        createStructureAddress(obj[address1.ForeignKeyName] || '', address1.Name, addr.Id)

                                                    } else {
                                                        createStructureAddress('', address1.Name, addr.Id)
                                                    }
                                                }
                                            }}
                                            disabled={address1.disable}
                                            valueField={address1.ForeignTableToPassId}
                                        />
                                    ) : address1.Type === 'string' && address1.Name === 'Notes' ? (
                                        <M_InputTextField
                                            key={key1}
                                            type={"text"}
                                            label={address1.NormalizedName}
                                            onChange={(e) => createStructureAddress(e.target.value, address1.Name, addr.Id)}
                                            required={address1.IsRequired}
                                            disabled={address1.disabled}
                                            value={addr[address1.Name] || ""}
                                        />
                                    ) : address1.Type === 'string' ? (
                                        <M_InputTextField
                                            key={key1}
                                            type={"text"}
                                            label={address1.NormalizedName}
                                            onChange={(e) => createStructureAddress(e.target.value, address1.Name, addr.Id)}
                                            required={address1.IsRequired}
                                            disabled={address1.disabled}
                                            value={addr[address1.Name] || ""}
                                        />
                                    ) : address1.Type === 'datetime' && addr.AddressType !== 'Charge/Discharge' ? (
                                        <M_InputTextField
                                            key={key1}
                                            type={"datetime-local"}
                                            label={addr.AddressType === 'Pickup' ? "Cut Off Levante" : "Cut Off Entrega"}
                                            onChange={(e) => createStructureAddress(e.target.value, address1.Name, addr.Id)}
                                            required={addr.AddressType !== 'Charge/Discharge' ? address1.IsRequired : false}
                                            disabled={address1.disabled}
                                            value={addr[address1.Name] || ""}
                                            maxDate={addr.AddressType === 'Pickup' && orderService.get('TransportDate') ? new Date(orderService.get('TransportDate')).toISOString().slice(0, 16) : null}
                                            minDate={addr.AddressType === 'Delivery' && orderService.get('TransportDate') ? new Date(orderService.get('TransportDate')).toISOString().slice(0, 16) : null}
                                        />
                                    ) : null}
                                </div>
                            ))}
                        </div>
                        {addr.AddressType === 'Charge/Discharge' && (
                            <div className='divDeleteAddress'>
                                <img src="/icons/svgsDaNet/trash-2.svg"
                                    style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                    alt="Delete" className='iconDeleteAddress' onClick={() => deleteAddress(addr.Id)}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
